// Built-in Modules
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpModule, JsonpModule } from '@angular/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

// Modules
import { AppRoutingModule } from './app-routing.module';
import { AdminModule } from './components/admin/admin.module';

// Guards
import { AdminAccessGuard } from './guards/admin-access.guard';
import { UserAccessGuard } from './guards/user-access.guard';

// Services
import { ServiceModule } from './shared/service.module';

// Directives

// Pipes
import { PipeModule } from './shared/pipe.module';

// Components
import { AppComponent } from './app.component';
import { LoginComponent } from './components/login/login.component';
import { LogoutComponent } from './components/logout/logout.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { ExportDirective } from './export.directive';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    NotFoundComponent,
    LogoutComponent,
    ExportDirective
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    JsonpModule,
    HttpModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    AppRoutingModule,
    AdminModule,
    PipeModule,
    ServiceModule
  ],
  entryComponents: [
  ],
  providers: [
    AdminAccessGuard,
    UserAccessGuard,
  ],
  bootstrap: [
    AppComponent
  ]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts